import { PrimaryButton } from '@designsforhealth/dfh-react-components'
import styled, { keyframes } from 'styled-components'

const fadeInAnimation = keyframes`
  from {
    transform: scale(.50);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
`

const fadeOutAnimation = keyframes`
  from { transform: scale(1); opacity: 1; }
  to { transform: scale(.50); opacity: 0; }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 20px;
`

export const Button = styled(PrimaryButton)`
  --btn-line-height: 19px;
  max-height: 50px;
  background-color: ${({ theme }) => theme.colors.component.backgroundDarkBlue};
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-size: 16px;
  font-weight: 700;
  text-transform: none;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  &:hover {
    background-color: #0b2648cc;
  }
`

export const SuccessfulRequestToast = styled.div<{ $fadeIn: boolean }>`
  display: ${({ $fadeIn }) => ($fadeIn ? 'inline-block' : 'none')};
  visibility: ${({ $fadeIn }) => ($fadeIn ? 'visible' : 'hidden')};
  animation: ${({ $fadeIn }) => ($fadeIn ? fadeInAnimation : fadeOutAnimation)} 500ms linear;
  transition: visibility 500ms linear;
  padding: 15px;
  font-size: 14px;
  width: 100%;
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.brand.white};
  background-color: ${({ theme }) => theme.colors.semantic.success};
  margin: 10px 0 10px auto;
`

export const ErrorRequestToast = styled.div<{ $fadeIn: boolean }>`
  display: ${({ $fadeIn }) => ($fadeIn ? 'inline-block' : 'none')};
  visibility: ${({ $fadeIn }) => ($fadeIn ? 'visible' : 'hidden')};
  animation: ${({ $fadeIn }) => ($fadeIn ? fadeInAnimation : fadeOutAnimation)} 500ms linear;
  transition: visibility 500ms linear;
  padding: 15px;
  font-size: 14px;
  width: 100%;
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.brand.white};
  background-color: ${({ theme }) => theme.colors.semantic.error};
  margin: 10px 0 10px auto;
`
